var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cards-playbook"}},[(_vm.$store.getters.loading)?_c('Loader'):_vm._e(),_c('Header',{attrs:{"text":_vm.$route.meta.header}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }